<template>
    <div>
     <div v-for="(month) in  mobile">
            <div class="month border border-left-0 border-right-0 border-bottom-0 p-3 mt-2 mb-2">
                <div class="d-block fw-500 fs-xxl color-primary-800">
                    {{month.period}}
                </div>


               <div v-for="item in month.expenses">


                    <div v-if="item.expense != null">
                        <div class="nomer">
                            <span class="fs-xl badge badge-warning">{{item.phone}}</span>
                            <div>Лiмiт {{item.limit}} грн./мiс. Тариф.план {{item.tarif}} </div>
                        </div>


                        <table  class="table table-striped limit table-responsive-xl ">
                            <thead>
                            <tr>
                                <th>Абонплата</th>
                                <th class="small_text">Понад пакет. хв. + мiж. дзв. </th>
                                <th>Понад пакет. смс, MB + дод. послуги </th>
                                <th>Роумiнг</th>
                                <th>Всього</th>
                                <th>Понад лiмiту</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="warning ">
                                <td>
									<span class="fs-xl">
										{{item.expense.AbonPlata}}
									</span>

								</td>
                                <td>
									<span class="fs-xl">
										{{item.expense.StoimZvonkov}}
									</span>
								</td>
                                <td>
									<span class="fs-xl">
										{{item.expense.DopYslygi}}
									</span>
								</td>

                                <td>
									<span class="fs-xl">
										{{item.expense.Rouming}}
									</span>
								</td>

                                <td>
									<span class="fs-xl">
										{{item.expense.Vsego}}
									</span>
								</td>
                                <td>
									<div class="fs-xl" :class="{'badge border border-danger text-danger ' : parseInt(item.expense.SverchLimita) < 0}">
										{{item.expense.SverchLimita}}
									</div>

								</td>
                            </tr>

                            </tbody>
                        </table>


                    </div>
                   <div v-else>
                        Даннi очiкуются з 10 числа
                   </div>
               </div>
            </div>
       </div>
    </div>
</template>

<script>
    export default {
        name: "mobile",
		props: {
			user_id: {
				type: Number,
				default: 0,
			}
		},

		data() {
			return  {
				mobile: {},
			}
		},
        created() {
			this.getUserData();
        },

        methods : {
			async getUserData() {
				await api.get('/user/'+this.user_id +'/mobile/expenses').then(({data}) => {
					if (data.status === "operation_success") {
						this.mobile = data.data;
					}
				}).catch(err => {
					console.log(err);
				});
			},
		}
    }
</script>

<style scope>

</style>
